import React, { useState } from 'react';
import Xsvg from './SVG/Xsvg';
import { useData } from '../hooks/useContext';
import { IUseData } from '../interfaces';
import { CONFIG } from '../config';

interface Search2Props {
  searchFunction: Function;
  onResult: Function;
}

const Search2 = ({ searchFunction, onResult }: Search2Props) => {
  const [input, setInput] = useState<string>('');
  const [searchReq, setSearchReq] = useState<string>('');
  const [findedItemsCount, setFindedItemsCount] = useState<number>(0);
  const [searchRes, setSearchRes] = useState<boolean>(false);

  const {
    theme,
    //searchRes,
    // setSearchRes,
    // searchReq,
  } = useData() as IUseData;

  async function search(req: string) {
    if (req) {
      const data = await searchFunction(req);

      setInput('');
      setSearchReq(req);
      setFindedItemsCount(data.length);
      setSearchRes(true);

      onResult(data);
      return data;
    }
  }

  const clearSearch = () => {
    setSearchRes(false);

    onResult(null);
  };

  return (
    <div className="flex flex-col mt-10">
      <div className="flex flex-row">
        <div className={'flex flex-row w-full rounded-full overflow-hidden' + theme.secondary}>
          <input
            id="searchInput"
            value={input}
            className={'py-2 px-8 w-full outline-none placeholder:font-semibold' + theme.secondary}
            placeholder="Поиск"
            type="text"
            aria-label="Строка поиска"
            // title="Строка поиска"
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
              e.keyCode === 13 && e.currentTarget.id === 'searchInput' ? search(input) : undefined
            }
          />
          {input ? (
            <button className="mx-2 font-semibold" onClick={() => setInput('')} title="Очистить строку поиска">
              <Xsvg color="#000000" />
            </button>
          ) : null}
        </div>
        <button
          className={'ms-2 px-5 py-[10px] font-semibold rounded-full' + theme.active}
          onClick={() => search(input)}
        >
          Найти
        </button>
      </div>
      {searchRes ? (
        <div className="px-4 flex flex-col md:flex-row my-2 justify-between">
          <div className="flex flex-col md:flex-row">
            <button
              className={CONFIG.BLUE_OR_GREEN_DESIGN ? 'text-[#4765DA] w-fit' : 'text-[#207F4B] w-fit'}
              onClick={() => clearSearch()}
            >
              Очистить поиск
            </button>
            <div className="md:mx-3">
              {'Вы искали: '}
              <button
                className={CONFIG.BLUE_OR_GREEN_DESIGN ? 'text-[#4765DA] w-fit' : 'text-[#207F4B] w-fit'}
                onClick={() => setInput(searchReq)}
              >
                {searchReq}
              </button>
            </div>
          </div>

          <div className="">{'Найдено объектов: ' + findedItemsCount}</div>
        </div>
      ) : null}
    </div>
  );
};

export default Search2;
